"use client";

import { TextField } from "../../../../shared";
import {
    Box,
    Button,
    Modal,
    ModalDialog,
    ModalClose,
    DialogTitle,
    DialogContent,
    DialogActions,
    Stack,
} from "@mui/joy";
import { useState, useEffect } from "react";

interface ColorFormProps {
    color?: any;
    onSubmit: (data: any) => void;
    onClose: () => void;
}

export function ColorForm({ color, onSubmit, onClose }: ColorFormProps) {
    const [formData, setFormData] = useState({
        Name: "",
        LightHex: "",
        DarkHex: "",
    });

    useEffect(() => {
        if (color) {
            setFormData({
                Name: color.Name || "",
                LightHex: color.LightHex || "",
                DarkHex: color.DarkHex || "",
            });
        }
    }, [color]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const submitData = color ? { ...formData, Id: color.Id } : formData;
        onSubmit(submitData);
    };

    return (
        <Modal open={true} onClose={onClose}>
            <ModalDialog size="md">
                <ModalClose />
                <DialogTitle>{color ? "Edit Color" : "Add Color"}</DialogTitle>
                {/* <form onSubmit={handleSubmit}>
                    <DialogContent>
                        <Stack spacing={2}>
                            <TextField
                                label="Name"
                                value={formData.Name}
                                onChange={(e) => setFormData({ ...formData, Name: e.target.value })}
                                required
                            />
                            <TextField
                                label="Light Color (Hex)"
                                value={formData.LightHex}
                                onChange={(e) => setFormData({ ...formData, LightHex: e.target.value })}
                                placeholder="#bfdbfe"
                                required
                            />
                            <TextField
                                label="Dark Color (Hex)"
                                value={formData.DarkHex}
                                onChange={(e) => setFormData({ ...formData, DarkHex: e.target.value })}
                                placeholder="#2563eb"
                                required
                            />
                        </Stack>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button type="submit">{color ? "Update" : "Create"}</Button>
                    </DialogActions>
                </form> */}
            </ModalDialog>
        </Modal>
    );
}
